// modules
import React, { FC } from 'react';
import { Text, View } from '@upstox/upstox-ui';
import LocaleService from 'modules/Localization';
// styles
import * as css from './styles';

const PriceAlertsEmptyState: FC = () => (
  <View css={css.container}>
    <Text variant="heading2" css={css.heading}>
      {LocaleService.translate('PRICE_ALERTS_EMPTY_STATE_HEADING')}
    </Text>
    <Text variant="meta">
      {LocaleService.translate('PRICE_ALERTS_EMPTY_STATE_SUB_HEADING')}
    </Text>
  </View>
);

export default PriceAlertsEmptyState;
